import type { Dependencies } from "@redux/store";
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { EditAndApproveExternalProviderBatchRequestBody } from "@shared-kernel/application/ports/admin/admin-repository";

export const editAndApproveExternalProviderBatchRequest = createAsyncThunk<
  void,
  EditAndApproveExternalProviderBatchRequestBody,
  { extra: Partial<Dependencies> }
>(
  "externalProviderBatchRequests/editAndApproveExternalProviderBatchRequest",
  async (body: EditAndApproveExternalProviderBatchRequestBody, { extra: { adminRepository } }) => {
    return adminRepository!.editAndApproveExternalProviderBatchRequest(body);
  },
);

export const resetEditAndApproveExternalProviderBatchRequest = createAction(
  "externalProviderBatchRequests/resetEditAndApproveExternalProviderBatchRequest",
);
